// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "理论力学",
      "tec": "解淑倩",
      "week": "1-9,12周",
      "add": "教学楼D座517机械AISEC"
    },
    {
      "sub": "大学英语读写（三）",
      "tec": "林琳",
      "week": "1-12周",
      "add": "教学楼D座518机械AISEC"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "计倩",
      "week": "1,3,5,7,9,13,15,17周",
      "add": "教学楼A座418机械"
    },
    {
      "sub": "科技文献检索",
      "tec": "董玉萍",
      "week": "1-4周",
      "add": "教学楼D座518机械AISEC"
    },
    0
  ],
  "2": [
    {
      "sub": "物理实验",
      "tec": "孙丽媛",
      "week": "1-5,7-9,12-15周",
      "add": "教学楼B座207"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-2,5,7-9,12-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "创新创业基础Ⅰ",
      "tec": "高强",
      "week": "1-9,12-14周",
      "add": "新型电力系统大楼318机械"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "理论力学",
      "tec": "解淑倩",
      "week": "1-9,12周",
      "add": "教学楼D座518机械AISEC"
    },
    {
      "sub": "材料科学",
      "tec": "徐玲",
      "week": "1-9,12-18周",
      "add": "教学楼A座317机械"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-2,5,7-9,12-17周",
      "add": "教学楼C座309教务"
    },
    0,
    {
      "sub": "大学英语听说（三）",
      "tec": "林琳",
      "week": "1-16周",
      "add": "教学楼D座518机械AISEC"
    },
    0,
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "1-4周",
      "add": "教学楼C座210教务"
    }
  ],
  "5": [
    {
      "sub": "概率论与数理统计",
      "tec": "计倩",
      "week": "1-5,7-9,12-19周",
      "add": "教学楼A座418机械"
    },
    {
      "sub": "明辨性思维",
      "tec": "赵勤",
      "week": "1-9,12-18周",
      "add": "教学楼D座419文法"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "郝策",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男网",
        "tec": "李莉",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "搏击",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "足球",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男羽",
        "tec": "王莹莹",
        "week": "1-3,5-18周",
        "add": "健美操"
      },
      {
        "sub": "男网",
        "tec": "李灏",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男乒",
        "tec": "张慧",
        "week": "1-18周",
        "add": "健美操"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
